import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

import type { RequisitionFlow } from '@core/requisitions-types';

import type { RequisitionsAbilities } from '../../data/list/requisitions-list-data.service';
import { RequisitionsListDataService } from '../../data/list/requisitions-list-data.service';

@Injectable()
export class RequisitionsListFacade {
  protected readonly store = inject(Store);
  protected readonly requisitionsData = inject(RequisitionsListDataService);

  private abilities: RequisitionsAbilities;
  private flows: RequisitionFlow[];
  private defaultFlowMissing: boolean;

  private ngOnDestroy$ = new Subject<void>();

  constructor() {
    const requisitionsData = this.requisitionsData;

    requisitionsData.data$
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(({ abilities, flows, defaultFlowIsMissing }) => {
        this.flows = flows;
        this.abilities = abilities;
        this.defaultFlowMissing = defaultFlowIsMissing;
      });
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public get hasCreatedFlows(): boolean {
    return !!this.flows.length;
  }

  public get isDefaultFLowMissing(): boolean {
    return this.defaultFlowMissing;
  }

  public get canEditRequisitions(): boolean {
    return this.abilities.manageRequisitions;
  }

  public get canCreateRequisitions(): boolean {
    return this.abilities.manageRequisitions && this.hasCreatedFlows;
  }

  public get canCreateJobs(): boolean {
    return this.abilities.manageJobs;
  }

  public get canManageRequisitionsSettings(): boolean {
    return this.abilities.manageCompany;
  }
}
